import _ from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import Actions from '../../../../actions'
import HomeEditForm from '../../../../components/forms/screens/HomeEditForm'
import { Spinner } from '../../../../components/generic'
import { history } from '../../../../store'
import { withRouter } from '../../../../withRouter'

export class HomeProfileEdit extends Component {
  componentDidMount() {
    this.props.addForm(this.props.home)
  }

  componentDidUpdate(nextProps) {
    if (!this.props.home && nextProps.home) {
      this.props.addForm(nextProps.home)
    }
  }

  render() {
    const { home } = this.props
    if (!home) return <Spinner />
    return <HomeEditForm router={history} />
  }
}

HomeProfileEdit.propTypes = {
  addForm: PropTypes.func.isRequired,
  home: PropTypes.object
}

const mapStateToProps = (state, props) => {
  const { id } = props.router.params
  return {
    home: _.find(state.data.homes, { id })
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addForm: (profile) =>
      dispatch(
        Actions.addForm({
          formId: 'editHome',
          initial: profile
        })
      )
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HomeProfileEdit)
)
